import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  Autocomplete,
  Chip,
  Divider,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Grid from "@mui/material/Grid2";
import { useFetchCustomersQuery } from "../store/services/customerApi";
import dayjs from "dayjs";
import {
  useCeateMonthlyReportByCustomerMutation,
  useGetCustomerMonthlyReportQuery,
} from "../store/services/reportApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { toast } from "react-toastify";
import { cellSX, layoutCSS } from "../component/common/commonStyle";
import Loader from "../component/common/Loader";
const CustomerMonthlyReport = () => {
  const [search, setSearch] = useState("");
  const [selectCustomer, setSelectedCustomer] = useState(null);
  const [type, setType] = useState("sms");
  const [customer, setCustomer] = useState(null);
  const [startdate, setStartDate] = useState(dayjs());
  const [enddate, setEndDate] = useState(dayjs());
  const [dateError, setDateError] = useState("");
  const [page, setPage] = useState(1);
  const { data: getCustomer, isLoading } = useFetchCustomersQuery();
  const { data: getCustReport, refetch: refetchReport } =
    useGetCustomerMonthlyReportQuery();
  const [reqReport, { isLoading: isCreateLoading }] =
    useCeateMonthlyReportByCustomerMutation();
  console.log({
    selectCustomer: selectCustomer?.customer_profile?.customer_id,
  });

  useEffect(() => {
    if (!startdate?.isValid() || !enddate?.isValid()) {
      setDateError("Invalid date selected");
      return;
    }
    const maxDays = startdate.daysInMonth();
    const dayCount = enddate.diff(startdate, "day") + 1;
    if (dayCount <= maxDays) {
      return;
    } else {
      alert(
        `Date range should be at most ${maxDays} days. And you selected ${dayCount} days`
      );
    }
  }, [startdate, enddate]);

  const reqForCustomerMonthlyReport = async () => {
    try {
      const validationErrors = [];

      if (!selectCustomer?.customer_profile)
        validationErrors.push("Customer is required");
      if (!type)
        validationErrors.push("type is required (e.g., sms, api, clicker)");
      if (!startdate) validationErrors.push("startdate is required");
      if (!enddate) validationErrors.push("enddate is required");

      const validTypes = ["sms", "api", "clicker"];
      if (type && !validTypes.includes(type)) {
        validationErrors.push(
          `Invalid type. Must be one of: ${validTypes.join(", ")}`
        );
      }

      if (validationErrors.length > 0) {
        validationErrors.forEach((msg) => toast.warn(msg));
        return;
      }
      const data = {
        customer_id: selectCustomer?.customer_profile?.customer_id,
        type,
        startdate,
        enddate,
      };
      const res = await reqReport(data);
      if (res?.data?.status) {
        refetchReport();
        toast.success(res?.data?.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  if (isCreateLoading) {
    return <Loader />;
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={layoutCSS}>
        <Typography variant="h6" sx={{ mb: 1, fontSize: '0.9rem',fontWeight:"bold" }}>
          Month Wise Report
        </Typography>
        <Grid container spacing={2} mb={1}>
          <Grid item xs={12} md={6} lg={2.3}>
            <Autocomplete
              options={getCustomer?.data || []}
              getOptionLabel={(option) =>
                option.customer_profile?.customer_name || ""
              }

              loading={isLoading}
              onInputChange={(event, newInputValue) => {
                setSearch(newInputValue);
              }}
              onChange={(event, newValue) => {
                setSelectedCustomer(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select User"
                  fullWidth
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {isLoading ? <span>Loading...</span> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                  sx={{
                    width: 130,
                    fontSize: "0.75rem",
                    "& .MuiInputBase-input": {
                      fontSize: "0.75rem",
                      padding: "6px 8px",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={2.3}>
            <FormControl
              fullWidth
              size="small"
              sx={{
                width: 130,
                fontSize: "0.75rem",
                "& .MuiInputBase-input": {
                  fontSize: "0.75rem",
                  padding: "6px 8px",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.75rem",
                },
              }}
            >
              <InputLabel id="report-type-label">Report Type</InputLabel>
              <Select
                labelId="report-type-label"
                value={type}
                label="Report Type"
                onChange={(e) => setType(e.target.value)}
              >
                <MenuItem value="sms">SMS</MenuItem>
                <MenuItem value="api">API</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={2.3}>
            <DatePicker
              label="From"
              value={startdate}
              format="DD-MM-YYYY"
              maxDate={dayjs()}
              onChange={(newValue) => {
                if (dayjs(newValue).isValid()) {
                  setStartDate(dayjs(newValue));
                }
              }}
              slotProps={{
                textField: {
                  size: "small",
                  sx: {
                    width: 130,
                    fontSize: "0.75rem",
                    "& .MuiInputBase-input": {
                      fontSize: "0.75rem",
                      padding: "6px 8px",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  },
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={2.3}>
            <DatePicker
              label="To"
              value={enddate}
              format="DD-MM-YYYY"
              maxDate={dayjs()}
              onChange={(newValue) => {
                if (dayjs(newValue).isValid()) {
                  setEndDate(dayjs(newValue));
                }
              }}
              slotProps={{
                textField: {
                  size: "small",
                  sx: {
                    width: 130,
                    fontSize: "0.75rem",
                    "& .MuiInputBase-input": {
                      fontSize: "0.75rem",
                      padding: "6px 8px",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  },
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={2.3}>
            <Button
              fullWidth
              sx={{
                height: 30,
                minWidth: 130,
                fontSize: "0.75rem",
                padding: "6px 8px",
              }}
              variant="contained"
              onClick={() => reqForCustomerMonthlyReport()}
            >
              Request
            </Button>
          </Grid>
        </Grid>

        {/* </Paper> */}
        <Divider />
        <TableContainer component={Paper}>
          <Table>
            <TableHead
              sx={{
                bgcolor: '#0288d1',
                "& th": {
                  color: "white",
                  fontSize: '0.8rem',
                  borderBottom: '0.5px solid #B0B0B0',
                  padding: '4px',

                },
              }}
            >
              <TableRow >
                <TableCell sx={{ borderRight: '0.5px solid #B0B0B0' }}>Report Id</TableCell>
                <TableCell sx={{ borderRight: '0.5px solid #B0B0B0' }}>Customer Name</TableCell>
                <TableCell sx={{ borderRight: '0.5px solid #B0B0B0' }}>Create Date</TableCell>
                <TableCell sx={{ borderRight: '0.5px solid #B0B0B0' }}>From Date</TableCell>
                <TableCell sx={{ borderRight: '0.5px solid #B0B0B0' }}>To Date</TableCell>
                <TableCell sx={{ borderRight: '0.5px solid #B0B0B0' }}>Service Type</TableCell>
                <TableCell sx={{ borderRight: '0.5px solid #B0B0B0' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getCustReport?.data?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={cellSX}>{item?.customer_req_id}</TableCell>
                  <TableCell sx={cellSX}>{item?.customerData?.customer_name}</TableCell>
                  <TableCell sx={cellSX}>
                    {dayjs(item?.createdat).format('DD/MM/YYYY ')}
                  </TableCell>
                  <TableCell sx={cellSX}>
                    {dayjs(item?.startdate).format('DD/MM/YYYY ')}
                  </TableCell>
                  <TableCell sx={cellSX}>
                    {dayjs(item?.enddate).format('DD/MM/YYYY ')}
                  </TableCell>
                  <TableCell sx={cellSX}>{item?.reportcategory}</TableCell>
                  <TableCell sx={cellSX}>
                    {!item?.reporturl ? (
                      <Chip label={item?.status} />
                    ) : (
                      <Button>Download</Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

          </Table>
        </TableContainer>
      </Box>
    </LocalizationProvider>
  );
};

export default CustomerMonthlyReport;
